export default "__VITE_ASSET__77190f6b__"